import { cn } from "@omni/utils/styles";
import { ComponentProps, useId } from "react";
import { GroupBase, default as ReactSelect } from "react-select";

type Props<
    Option = unknown,
    IsMulti extends boolean = false,
    Group extends GroupBase<Option> = GroupBase<Option>
> = ComponentProps<typeof ReactSelect<Option, IsMulti, Group>> & {
    isValid?: boolean;
    isInvalid?: boolean;
};

export const Select = <
    Option = unknown,
    IsMulti extends boolean = false,
    Group extends GroupBase<Option> = GroupBase<Option>
>({
    className,
    isValid = false,
    isInvalid = false,
    ...props
}: Props<Option, IsMulti, Group>) => {
    const id = useId();
    return (
        <ReactSelect<Option, IsMulti, Group>
            id={props.name || id}
            instanceId={props.name || id}
            {...props}
            className={cn(
                "tw:group-[*]/inputgroup:not-first:rounded-l-none!",
                "tw:group-[*]/inputgroup:not-last:rounded-r-none!",
                "tw:group-[*]/inputgroup:not-last:-mr-px!",
                "tw:focus-within:z-20!",
                className
            )}
            classNames={{
                control: ({ isFocused }) =>
                    cn(
                        "tw:h-10! tw:min-h-auto! tw:gap-2! tw:flex! tw:bg-white tw:border! tw:border-grey-input tw:transition-shadow!",
                        {
                            "tw:ring-inset! tw:ring-3! tw:ring-information/40! tw:border-information!":
                                isFocused
                        },
                        {
                            "tw:border-danger! tw:ring-danger/40!": isInvalid,
                            "tw:border-success! tw:ring-success/40!": isValid
                        }
                    ),
                container: () => "tw:w-full",
                valueContainer: () => "tw:pr-0!",
                clearIndicator: () => "tw:pl-0!",
                loadingIndicator: () => "tw:pl-0!",
                dropdownIndicator: () => "tw:pl-0!",
                indicatorSeparator: () => "tw:mr-2",
                input: () => "input-select"
            }}
        />
    );
};
